import { call, put } from 'redux-saga/effects';

import {
  productBrands,
  productRanges,
  products,
  setProductBrandsLoadingStatus,
  setProductRangesLoadingStatus,
  setProductsLoadingStatus,
} from 'actions/product.actions';
import { ProductAPI } from 'services/product.api';
import { ActionType } from 'interfaces';
import { LOADING_STATUS } from 'constants/status';

export function* getProductBrandsSaga({ payload }: ActionType): unknown {
  try {
    yield put(setProductBrandsLoadingStatus(LOADING_STATUS.PENDING));
    const { data } = yield call(
      ProductAPI.getChallengeProductsBrands,
      payload.challengeId,
    );
    yield put(productBrands.success(data));
    yield put(setProductBrandsLoadingStatus(LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(productBrands.failure(error));
    yield put(setProductBrandsLoadingStatus(LOADING_STATUS.REJECTED));
  }
}
export function* getProductRangesSaga({ payload }: ActionType): unknown {
  try {
    yield put(setProductRangesLoadingStatus(LOADING_STATUS.PENDING));
    const { data } = yield call(
      ProductAPI.getChallengeProductsRanges,
      payload.challengeId,
    );
    yield put(productRanges.success(data));
    yield put(setProductRangesLoadingStatus(LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(productRanges.failure(error));
    yield put(setProductRangesLoadingStatus(LOADING_STATUS.REJECTED));
  }
}
export function* getProductsSaga({ payload }: ActionType): unknown {
  const { params, challengeId } = payload;

  try {
    yield put(setProductsLoadingStatus(LOADING_STATUS.PENDING));
    const { data } = yield call(
      ProductAPI.getChallengeProducts,
      params,
      challengeId,
    );
    yield put(products.success(data, params, challengeId));
    yield put(setProductsLoadingStatus(LOADING_STATUS.RESOLVED));
  } catch (error) {
    yield put(productRanges.failure(error));
    yield put(setProductsLoadingStatus(LOADING_STATUS.REJECTED));
  }
}
